// Place any custom Javascript or jQuery in this file.
// If code needs to wait until the DOM is ready, place within the jQuery function below.

function displayModal(e) {
	let t = document.querySelector("#" + e);
	t.classList.remove("hide"),
		gsap.to(t, { opacity: 1, scale: 1, duration: 0.5 });
}
function closeModal(e) {
	let t = document.querySelector("#" + e);
	gsap.to(t, { opacity: 0, duration: 0.5 }), t.classList.add("hide");
}

(function ($) {
	// Variables and DOM Caching.
	var $highlightNav = $(".number-anchors li"),
		$highlights = $(".highlight-content"),
		highlightsIndex = 0;

	$highlightNav.click(function () {
		// Reset all highlights
		$highlightNav.removeClass("current");
		$highlights.removeClass("current");

		// Add .current to the selected nav item and content div
		$(this).addClass("current");
		highlightsIndex = $(this).data("highlight");

		$highlights.each(function () {
			if ($(this).data("highlight") == highlightsIndex) {
				$(this).addClass("current");
			}
		});
	});

	// Create parallax elements with Rellax.js
	if ($(".hero-sub-banner-parallax").length > 0) {
		var rellax = new Rellax(".rellax", {
			speed: 2,
			center: true,
		});
	}

	// Extra parallax detection for FBM, due to Ninja Forms causing conflicts
	/*
	if ($('.page-id-32').length) {
		var $window = $(window),
			testNF = $('.fbm-contact .nf-form-cont');

		var checkNF = setInterval(function() {
			testNF = $('.fbm-contact .nf-form-cont');

			if (testNF.length) {
				clearInterval(checkNF);
				initializeParallax(document.querySelector('.viewport'));
			}
		}, 100);
	}
	*/

	// DeBounce Function
	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this,
				args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	Array.prototype.rotate = (function () {
		// save references to array functions to make lookup faster
		var push = Array.prototype.push,
			splice = Array.prototype.splice;

		return function (count) {
			var len = this.length >>> 0, // convert to uint
				count = count >> 0; // convert to int

			// convert count to value in range [0, len)
			count = ((count % len) + len) % len;

			// use splice.call() instead of this.splice() to make function generic
			push.apply(this, splice.call(this, 0, count));
			return this;
		};
	})();

	// Career Pathways Interactive Wheel (+ search upgrade from 2020)
	var win = $(window),
		pathways = $(".ig-pathway"),
		titles = pathways.children(".ig-pathway-title");
	(wheel = $("#ig_pathways")),
		(graphic = $(".interactive-graphic")),
		(linkWrapper = $(".ig-links-wrapper")),
		(list = $(".ig-pathway-list li")),
		(mobileList = wheel.children(".ig-links-mobile")),
		(links = $(".ig-links")),
		(listItem = list.first()),
		(listReturn = $(".ig-pathway-return")),
		(bgClass = ""),
		(positions = [0, 1, 2, 3, 4, 5, 6, 7]),
		(degrees = 0),
		(pos = 0),
		(current = -1),
		(repeat = false);

	// Main search variables for pathway wheel. Uses a debounce for performance, and jQuery to power the filtering
	// Search tech located after wheel code.
	var $searchInput = $("#pathway-search"),
		searchInputHTML = document.getElementById("pathway-search"),
		$allElements = $(
			".ig-links, .ig-links > li, .ig-links-mobile, .ig-links-mobile > li"
		),
		$allItems = $(".ig-links > li, .ig-links-mobile > li"),
		$countWrap = $(".search-count-wrap"),
		$count = $(".search-count"),
		$termDisplay = $(".search-term"),
		term = "",
		searchCount = 0;

	// Start of search tech
	if ($searchInput.length) {
		// Temporarily change :contains to be case insensitive, only if the search field exists.
		$.expr[":"].contains = $.expr.createPseudo(function (arg) {
			return function (elem) {
				// return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
				return (
					$(elem)
						.text()
						.replace(/[^A-Za-z0-9]/g, "")
						.toUpperCase()
						.indexOf(arg.toUpperCase()) >= 0
				);
			};
		});
	}

	// Function that will run through the debounce
	var searchPathways = function () {
		// First, reset the wheel rotate/active settings if it was already in use.
		listReturn.click();

		// Then, hide all the line items and their wrappers
		$allElements.addClass("search-no");

		// Then store the input fields value as our search term.
		term = $searchInput.val();

		// Using the jQuery enhanced CSS ':contains' filter, loop through all the classes and remove the 'search-no' class on matching results. The final call to length at the end makes this a super concise 1-line call to do all the filtering and result info in one go.
		searchCount = $allItems
			.filter(":contains('" + term + "')")
			.removeClass("search-no")
			.parent()
			.removeClass("search-no")
			.addClass("active")
			.prev()
			.removeClass("search-no")
			.addClass("active").length;

		if ($allItems.length && term != "") {
			// Some variables are already created for the wheel, so reference code further up
			listReturn.addClass("active");
			$countWrap.addClass("active");
			graphic
				.removeClass("orange lightblue purple teal red green yellow blue")
				.addClass("activated searched");
			linkWrapper.addClass("displayed");

			// Update the search count & term display
			$termDisplay.html(term);

			if (searchCount != 1) {
				$count.html(searchCount + " search results");
			} else {
				$count.html(searchCount + " search result");
			}
		} else {
			// This clears all the search filtering. Since we reset the wheel at the start of the search, it should be ready to search again or navigate manually without any other changes.
			listReturn.removeClass("active");
			$countWrap.removeClass("active");
			graphic.removeClass(
				"orange lightblue purple teal red green yellow blue activated searched"
			);
			linkWrapper.removeClass("displayed");
			$allElements.removeClass("search-no");
			$allItems.parent().removeClass("active").prev().removeClass("active");
		}

		// Since the filter is so fast, make sure we get shown the top of the list again
		linkWrapper.scrollTop(0);
	};

	// Only set up the debounce and listener if the Pathway and search is detected.
	if ($searchInput.length) {
		// Set the seachPathways function to only fire if the keyup function stop for 0.5 seconds
		var searchDebounce = debounce(searchPathways, 300);

		// Attach the debounced function as a listener to only the input field.
		searchInputHTML.addEventListener("keyup", searchDebounce);
	}

	// Start of wheel selection code
	list.click(function (e) {
		listItem = $(this);

		pathways.get(listItem.data("target")).click();
	});

	pathways.click(function (e) {
		pos = pathways.index($(this));
		bgClass = $(this).data("active");
		// Clear the manual search results
		graphic.removeClass("searched");
		$allElements.removeClass("search-no");
		$countWrap.removeClass("active");
		$searchInput.val("");

		// Check to be sure we're not already clicking on the active slide.
		if (win.width() >= 768) {
			if (current != pos || repeat) {
				current = pos;
				repeat = false;

				titles.removeClass("active");
				$(this).children(".ig-pathway-title").addClass("active");

				list.removeClass("active");
				list.eq(pos).addClass("active");

				for (var i = 0; i < positions.length; i++) {
					if (positions[i] == pos) {
						if (i <= 4) {
							degrees += i * 45; // Example: on pos 6, click on 1, add 135 degress to 270 to rotate clockwise.
						} else {
							degrees -= (8 - i) * 45; // Example: on pos 6, click on 4, remove 90 degrees to rotate counter-clockwise.
						}

						positions.rotate(i);
					}
				}

				// Always rotate the wheel relative to the bottom (active) pathway.
				wheel.css({
					"-webkit-transform": "rotate(" + degrees + "deg)",
					"-moz-transform": "rotate(" + degrees + "deg)",
					"-ms-transform": "rotate(" + degrees + "deg)",
					transform: "rotate(" + degrees + "deg)",
				});

				listReturn.addClass("active");
				linkWrapper.addClass("displayed");
				graphic
					.removeClass("orange lightblue purple teal red green yellow blue")
					.addClass("activated " + bgClass);
				links.removeClass("active");
				links.filter('[data-pathway="' + bgClass + '"]').addClass("active");
			} else {
				listReturn.click();
			}
		} else {
			mobileList.eq(pos).toggleClass("active");
			$(this).children(".ig-pathway-title").toggleClass("mobile-active");

			wheel.css("transform", "");
			listReturn.click();
		}

		// Always snap to the top of the list regardless of change.
		linkWrapper.scrollTop(0);
	});

	listReturn.click(function () {
		repeat = true;

		// if (graphic.hasClass('searched')) {
		// 	$searchInput.val('');
		// }

		listReturn.removeClass("active");
		titles.removeClass("active");
		linkWrapper.removeClass("displayed");
		graphic.removeClass(
			"activated orange lightblue purple teal red green yellow blue activated searched"
		);
		links.removeClass("active");
		$allElements.removeClass("search-no");
	});

	var resizer = function () {
		if (win.width() < 768) {
			wheel.css("transform", "");
			listReturn.click();
		}
	};

	var windowResize = debounce(resizer, 250);

	window.addEventListener("resize", windowResize);

	// Annual Reports
	var reportSelect = $("#report_select");

	if (reportSelect.length) {
		var $reports = $(".report-year"),
			$reportWrap = $(".statewide-wrap"),
			$reportEyebrow = $("#report_eyebrow"),
			$descriptionTitle = $("#description_title"),
			$descriptionContent = $("#description_content"),
			$reportSpan = $reportEyebrow.find("span"),
			$selectVal = "";

		// Fire when the year selector is changed.
		reportSelect.change(function (event) {
			// Store the value of the selected <option> for multiple use.
			$selectVal = $(this).val();

			// Change the year in the eyebrow text to the currently selected year.
			$reportSpan.html($selectVal);

			if ($selectVal == "") {
				// If the blank option is selected, set everything back to original
				$reportWrap.removeClass("active");
				$reportEyebrow.addClass("invisible");

				$descriptionTitle.addClass("active");
				$descriptionTitle.removeClass("invisible");

				$descriptionContent.addClass("active");
				$descriptionContent.removeClass("invisible");
			} else {
				// If any year is selected, display the map and eyebrow text.
				$reportWrap.addClass("active");
				$reportEyebrow.removeClass("invisible");

				$descriptionTitle.addClass("invisible");
				$descriptionContent.addClass("invisible");
			}

			// Always remove all active classes from the reports as a fallback.
			$reports.removeClass("active");

			$descriptionTitle.removeClass("active");
			$descriptionContent.removeClass("active");

			// Find the year that corresponds with the <select> and add a class that will display it.
			$reports.filter("#year_" + $selectVal).addClass("active");
		});
	}

	$(".search-wrap").click(function (e) {
		e.stopPropagation();

		//    console.log('click');

		if (!$("body").hasClass("search-open")) {
			//   console.log('activate');

			$("body")
				.addClass("search-open")
				.one("click", function () {
					//   console.log('once');

					$("body").removeClass("search-open");
				});
		}
	});

	$(".search-submit").click(function (e) {
		if (!$("body").hasClass("search-open")) {
			e.preventDefault();

			$(".search-wrap").click();

			return false;
		}
	});

	// FBM Annual Reports - View All for Highlighted Year
	var highlightReports = $("#reports-highlights__grid"),
		viewAll = $("#reports-highlights__view-all"),
		viewLess = $("#reports-highlights__view-less"),
		reportAnchor = $(window);

	viewAll.click(function () {
		highlightReports.addClass("flex-wrap");
		viewAll.addClass("d-none").attr("aria-hidden", "false");
		viewLess.removeClass("d-none").attr("aria-hidden", "true");
	});

	viewLess.click(function () {
		highlightReports.removeClass("flex-wrap");
		viewLess.addClass("d-none").attr("aria-hidden", "false");
		viewAll.removeClass("d-none").attr("aria-hidden", "true");
	});

	// Year selector
	$("#reports-highlights__jump").change(function () {
		$("#year-" + $(this).val() + " .reports-years__toggle").click();
		window.location.hash = "year-" + $(this).val();
	});

	// Also, automatically open the accordion if loading a link with an anchor set
	if (window.location.hash) {
		$(window.location.hash + " .reports-years__toggle").click();
	}

	function resetMessage() {
		$("#download-result")
			.removeClass(
				"reports-queue__feedback_success reports-queue__feedback_error"
			)
			.text("");
	}

	function showMessage(text) {
		resetMessage();
		$("#download-result")
			.addClass("reports-queue__feedback_success")
			.text(text);
	}

	function showError(text) {
		resetMessage();
		$("#download-result").addClass("reports-queue__feedback_error").text(text);
	}

	function updatePercent(percent) {
		$("#progress_bar")
			.removeClass("hide")
			.find(".progress-bar")
			.attr("aria-valuenow", percent)
			.css({
				width: percent + "%",
			});
	}

	if (!JSZip.support.blob) {
		showError("This demo works only with a recent browser !");
		return;
	}

	// Work within the JSZip environment to cherry pick files and compile them into a single download.
	var Promise = window.Promise;
	if (!Promise) {
		Promise = JSZip.external.Promise;
	}

	function urlToPromise(url) {
		return new Promise(function (resolve, reject) {
			JSZipUtils.getBinaryContent(url, function (err, data) {
				if (err) {
					reject(err);
				} else {
					resolve(data);
				}
			});
		});
	}

	var $form = $(".reports-download").click(function (e) {
		e.stopPropagation();
		e.preventDefault();

		resetMessage();

		var zip = new JSZip();

		// find every checked item
		$(".reports-years__checkbox:checked").each(function () {
			var $this = $(this);
			var url = $this.data("url");
			var filename = url.replace(/.*\//g, "");
			zip.file(filename, urlToPromise(url), { binary: true });
		});

		// when everything has been downloaded, we can trigger the dl
		zip
			.generateAsync({ type: "blob" }, function updateCallback(metadata) {
				var msg = +metadata.percent.toFixed(2) + " %";
				if (metadata.currentFile) {
					msg += ", current file = " + metadata.currentFile;
				}
				showMessage(msg);
				updatePercent(metadata.percent | 0);
			})
			.then(
				function callback(blob) {
					// console.log(blob);
					// console.log(blob.size);
					// see FileSaver.js
					saveAs(blob, "fbm-annual-reports.zip");

					showMessage("done !");
				},
				function (e) {
					showError(e);
				}
			);

		return false;
	});

	// Keep count of checked files
	var checks = $(".reports-years__checkbox"),
		checkDisplay = $(".reports-queue"),
		checkCount = $(".download-count");
	checkQty = 0;

	$(".reports-years__checkbox").change(function (e) {
		checkQty = checks.filter(":checked").length;

		// console.log(checkQty);

		if (checkQty == 0) {
			checkDisplay.removeClass("active");
		} else {
			if (checkQty > 1) {
				checkCount.html(checkQty + " Files");
			} else {
				checkCount.html(checkQty + " File");
			}

			checkDisplay.addClass("active");
		}
	});

	// Campus Locations filter tech
	var $pathwaySelect = $("#pathway-select"),
		// $regionSelect	= $('#region-select'),
		$accordions = $(".campus-display__location"),
		$resultsMsg = $(".campus-filters__results");

	$("#campus-filters__submit").click(function (e) {
		// Shouldn't need this, but tossing in just to ensure we don't accidentally attempt a form submit.
		e.preventDefault();
		// Clear the plate by making all campuses inactive to start
		$accordions.addClass("inactive");

		// Then test the select field values.
		if ($pathwaySelect.val() == "") {
			// && $regionSelect.val() == '') {
			// If both come back as false/not selected, bring all campuses back into view.

			$accordions.removeClass("inactive");
		} else if ($pathwaySelect.val()) {
			// && $regionSelect.val()) {
			// If both are set, then filter the two in tandem (show campuses that only qualify for both results)
			$accordions
				.filter("." + $pathwaySelect.val() /*+ '.' + $regionSelect.val()*/)
				.removeClass("inactive");
		} else {
			// Lastly, apply the filters to one or the other.
			if ($pathwaySelect.val()) {
				$accordions.filter("." + $pathwaySelect.val()).removeClass("inactive");
			}
			// if ($regionSelect.val()) {
			// 	$accordions.filter('.' + $regionSelect.val()).removeClass('inactive');
			// }
		}

		if ($accordions.filter(".inactive").length == $accordions.length) {
			$resultsMsg.removeClass("inactive");
		} else {
			$resultsMsg.addClass("inactive");
		}

		// Same reason as preventDefault for this.
		return false;
	});

	// Reset link for filters
	$("#campus-filters__clear").click(function () {
		$accordions.removeClass("inactive");
		$resultsMsg.addClass("inactive");
		$pathwaySelect.val("");
		// $regionSelect.val('');
	});

	//Deans and Instructors page
	//This is here to watch for changes in DOM height that can throw off scrollTriggers and Timelines
	const container = $("body");
	var eventTimer;

	const heightObserver = new ResizeObserver(function () {
		// console.log('New scrollHeight', container[0].scrollHeight);
		clearTimeout(eventTimer);
		eventTimer = setTimeout(() => {
			ScrollTrigger.refresh();
		}, 1000);
	});

	container.children().each(function (index, child) {
		heightObserver.observe(child);
	});

	$(".overlay .modal-close").click(function (e) {
		$(".overlay").hide();
	});
	$("#open-map").click(function (e) {
		$(".overlay").css("display", "flex");
	});

	//Handles filtering of regions through select box
	$("#region-select").change(function (e) {
		sortRegion();
		sortExpertise();
	});

	//Handles filtering of expertise through select box
	$("#expertise-select").change(function (e) {
		sortExpertise();
	});

	function sortRegion() {
		resetResults();

		let region = $("#region-select").find(":selected").val();

		$(".campus-display__location").hide();

		if (region === "All") {
			$(".campus-display__location").show();

			$(".map-region").addClass("hovered");
			$(".map-region").off("mouseover mouseout");
		} else if (region === "Statewide") {
			$(".campus-display__location").hide();
			$(".map-region").removeClass("hovered");
			mapHover();
		} else {
			$(".map-region").removeClass("hovered");
			$("#" + region).show();
			$(".map-" + region).addClass("hovered");
			mapHover();

			$(".map-" + region).off("mouseover mouseout");
		}
		$("body").scrollTo(".region-section", { duration: 750 });
	}

	function sortExpertise() {
		let region = $("#region-select").find(":selected").val();
		let expertise = $("#expertise-select").find(":selected").val();

		//If there is no region selected there is nothing to sort so we select ALL first.
		if (region == 0) {
			//Find the option and mark it as selected
			$("#region-select").find('option[value="All"]').prop("selected", true);
			// Trigger the change event to update the select box UI
			$("#region-select").trigger("change");
		}

		if (expertise == "All") {
			sortRegion();
		} else {
			sortRegion();
			hideIntructorCards(expertise);
			hideParent("campus-display__location", expertise);
			hideParent("campus-display__department", expertise);
		}
	}
	//Resets elements to default on new expertise selection
	function resetResults() {
		$(".no-results").each(function () {
			$(this).hide();
		});
		$(".faculty-list__card").each(function () {
			$(this).show();
		});
		$(".campus-display__department").each(function () {
			$(this).show();
		});
		$(".campus-display__department").each(function () {
			$(this).show();
		});
		$(".map-region").each(function () {
			$(this).removeClass("filtered");
		});
	}

	//Searches for selected expertise and hides any parents that don't contain it
	function hideParent(element, expertise) {
		$("." + element)
			.not(".statewide-display__item")
			.each(function () {
				var $parentElement = $(this); // Current parent element in the loop

				// Check if none of the children or grandchildren have the class "specialty"
				if (!$parentElement.find("." + expertise).length) {
					if (element == "campus-display__location") {
						$(this).find(".no-results").show();
					} else {
						$parentElement.hide(); // Hide the current parent element
					}
				} else {
					let region = $("#region-select").find(":selected").val();
					if (element == "campus-display__location" && region == "All") {
						var selectedId = $(this).attr("id");

						addMapFilter(selectedId);
					}
				}
			});
	}

	function addMapFilter(mapRegion) {
		$(".map-" + mapRegion).addClass("filtered");
	}

	function hideIntructorCards(expertise) {
		$(".faculty-list__card").each(function () {
			// Check if none of the children or grandchildren have the class "specialty"
			if (!$(this).hasClass(expertise)) {
				$(this).hide(); // Hide the current parent element
			}
		});
	}

	//Handles filtering of regions through map clicks
	$(".map-region").click(function (e) {
		// console.log($("#region-select").find(":selected").val())
		$(".campus-display__location").hide();

		var clickedId = $(this).attr("id");
		var region = clickedId.replace("map-", "");
		// let region = $(this).find(":selected").val()
		// console.log(region)
		$("#region-select")
			.find('option[value="' + region + '"]')
			.prop("selected", true);

		// Trigger the change event to update the select box UI
		$("#region-select").trigger("change");

		mapHover();
		$(".map-region").removeClass("hovered");
		$(".map-region").removeClass("filtered");
		$("#" + region).show();
		$(this).off("mouseover mouseout");
		$(this).addClass("hovered");

		if ($(this).closest(".overlay").length > 0) {
			$(".overlay").hide();
		}
	});

	function mapHover() {
		$(".map-region").on("mouseover", function (event) {
			const { clientX, clientY } = event;
			const boundingRect = this.getBoundingClientRect();

			if (
				clientX >= boundingRect.left &&
				clientX <= boundingRect.right &&
				clientY >= boundingRect.top &&
				clientY <= boundingRect.bottom
			) {
				// Apply hover effect or trigger desired action
				$(this).addClass("hovered");
			}
		});

		$(".map-region").on("mouseout", function () {
			// Remove hover effect or reset action
			$(this).removeClass("hovered");
		});
	}

	ScrollTrigger.create({
		trigger: ".faculty-list",
		// endTrigger: ".footer-bar",
		start: "top top",
		end: "bottom bottom",
		pin: ".filter-container",
		pinSpacing: false,
		smooth: true,
		// markers: true
	});

	//handles hover effect for minnesota map
	ScrollTrigger.matchMedia({
		"(min-width: 768px)": function () {
			mapHover();

			gsap.registerPlugin(ScrollTrigger);

			// this setup code only runs when viewport is at least 600px wide
			// console.log("desktop")

			ScrollTrigger.create({
				trigger: ".region-section",
				start: "top top",
				end: "bottom bottom",
				pin: ".map-section.large-map",
				smooth: true,
				// markers: true
			});
		},
	});

	//Career Pathways
	if ($(".career-pathways").length > 0) {
		let trigger, circle, menu;
		function displayMenu() {
			circle.classList.add("hide"),
				menu.classList.remove("hide"),
				gsap.to(
					".career-icon",
					{
						opacity: 1,
						stagger: 0.05,
						delay: 0.125,
						duration: 1.2,
						ease: "none",
					},
					"-=.09357"
				);
		}
		// function displayModal(e) {
		// 	let t = document.querySelector("#" + e);
		// 	t.classList.remove("hide"),
		// 		gsap.to(t, { opacity: 1, scale: 1, duration: 0.5 });
		// }
		// function closeModal(e) {
		// 	let t = document.querySelector("#" + e);
		// 	gsap.to(t, { opacity: 0, duration: 0.5 }), t.classList.add("hide");
		// }
		window.onload = function () {
			(trigger = document.querySelector(".target")),
				(circle = document.querySelector(".circle")),
				(menu = document.querySelector(".menu")),
				trigger.addEventListener("click", displayMenu),
				window.matchMedia("(max-device-width: 576px)").matches &&
					(circle.classList.add("hide"), menu.classList.remove("hide"));
		};
	}
})(jQuery);
